<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Wczytaj'"></app-breadcrumb>
<div class="certificate-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!certificateFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wczytaj</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div [fxFlex]="'50'" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane zaświadczenia</h3>
        </div>

        <app-file-drag-and-drop [multiple]="true" [fileControl]="fileControl" [fileResults]="fileResults" acceptMime="application/pdf"   (uuid)="open($event)" [idd]="true"></app-file-drag-and-drop>

        <div fxLayout="row">
          <mat-slide-toggle color="accent"  [formControl]="trainingASFControl" >Szkolenie ASF </mat-slide-toggle>
        </div>

      </mat-card>
    </div>
    <div [fxFlex]="'50'" fxFlex.lt-md="100" fxLayoutGap="15px" *ngIf="iddCertificateObject">
      <mat-card>

<!--        <app-file-drag-and-drop [multiple]="true" [fileControl]="fileControl" [fileResults]="fileResults" acceptMime="application/pdf"></app-file-drag-and-drop>-->

<!--        <div fxLayout="row">-->
<!--          <mat-slide-toggle color="accent"  [formControl]="trainingASFControl" >Szkolenie ASF </mat-slide-toggle>-->
<!--        </div>-->

          <app-idd-trainings-certificates-details-view *ngIf="!modify" [fxFlex]="'100'"  [iddTrainingCertificateObject]="iddCertificateObject" (modifyClicked)="modify = true"></app-idd-trainings-certificates-details-view>
        <app-idd-trainings-certificates-edit *ngIf="modify" [fxFlex]="'100'"  [iddTrainingCertificateObject]="iddCertificateObject" (closeModification)="modify = false; open(iddCertificateObject.uuid)"></app-idd-trainings-certificates-edit>

      </mat-card>
    </div>


  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!certificateFormValid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Wczytaj</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
